import { SET_WEBHOOKS_FOR_REG_CHECKOUT } from './constants';

export const setWebHooks = payload => ({
    type: SET_WEBHOOKS_FOR_REG_CHECKOUT,
    payload: payload
});



// WEBPACK FOOTER //
// ./src/features/shared/webHooks/actionTypes.js